export enum getRoutes {
  home = '/',
  Login = '/login',
  Payment = '/payment',
  SignUp = '/signup',
  Profile = '/profile',
  Trainer = '/trainer',
  // Features = '/features',
  Sessions = '/sessions',
  Trainers = '/trainers',
  NotFound = '/not-found',
  Meeting = '/meeting/:id',
  VerifyOtp = '/verify-otp',
  Feedback = '/feedback/:id',
  EditProfile = '/edit-profile',
  ProfileCompletion = '/profile-completion',
  PaymentDetails = '/payment/:id',
  Subscription = '/subscription',
  SessionDetails = '/session/:id',
  TrainerDetails = '/trainers/:id',
  PrivateNotFound = '/404-not-found',
  FeedbackPending = '/feedback-pending',
  HelpUsImprove = '/help-us-improve/:id',
  SubscriptionSuccess = '/thank-you-purchase',
  GiftCard = '/gift-card-activation',
}
